import { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import brandConfig from 'brandConfig'
import { SplashScreen } from '../components/shared/loading-screen'
import { APP_CONFIG, GOOGLE_RECAPTCHA_SCRIPT_URL } from '../constants/appConfig'
import {
  BUY_POINTS_URL,
  CASHBACK_URL,
  EXCHANGE_POINTS_URL,
  PLAY_GAMES_URL,
  SCRATCH_CARDS_URL,
  HOME_URL,
  INVITE_FRIENDS_URL,
  MEMBERSHIP_URL,
  MY_ITEMS_URL,
  PAGE_NOT_FOUND_URL,
  POST_TO_EARN_URL,
  QUESTS_URL,
  REDIRECT_URL,
  SETTINGS_URL,
  SHOP_URL,
  STAKING_URL,
  TRANSACTIONS_URL
} from '../constants/navigation'
import requireAuth from '../hoc/requireAuth'
import requireLanguage from '../hoc/requireLanguage'
import { useScript } from '../hooks/useScript'
import useSumSubVerification from '../hooks/useSumSubVerification'
import { useWalletConnection } from '../hooks/useWalletConnection'
import AuthorizedLayoutContainer from './AuthorizedLayoutContainer'
import BuyPointsContainer from './BuyPointsContainer'
import CashbackContainer from './CashbackContainer'
import EarnViaContainer from './EarnViaContainer'
import ExchangePointsContainer from './ExchangePointsContainer'
import GamesContainer from './GamesContainer'
import MembershipContainer from './MembershipContainer'
import NftsContainer from './NftsContainer'
import OverviewContainer from './OverviewContainer'
import PageRedirectContainer from './PageRedirectContainer'
import QuestsContainer from './QuestsContainer'
import RedeemContainer from './RedeemContainer'
import StakingContainer from './staking/StakingContainer'
import TransactionsContainer from './TransactionsContainer'
import UserAccountContainer from './UserAccountContainer'
import InviteFriendsContainer from './InviteFriendsContainer'
import ProdegeContainer from './ProdegeContainer'

const HomeContainer = ({ ...props }) => {
  useScript(
    `${GOOGLE_RECAPTCHA_SCRIPT_URL}${APP_CONFIG.RECAPTCHA_ID}`,
    'recaptcha'
  )
  const features = brandConfig.features
  const {
    isExchangeEnabled,
    brandAppConfig,
    enablePurchasePoints,
    isQuestsEnabled
  } = props
  const {
    onWalletClick,
    renderWalletPopup,
    stakingContractResponse,
    openConnectModal
  } = useWalletConnection()

  const { initKYCProcess, kycComponent } = useSumSubVerification()

  const walletConnectProps = {
    onWalletClick,
    renderWalletPopup,
    stakingContractResponse,
    openConnectModal
  }
  return (
    <AuthorizedLayoutContainer
      isQuestsEnabled={isQuestsEnabled}
      walletConnectProps={walletConnectProps}
      initKYCProcess={initKYCProcess}
      {...props}
    >
      <Suspense fallback={<SplashScreen />}>
        <Routes>
          <Route
            path={HOME_URL}
            element={
              <OverviewContainer walletConnectProps={walletConnectProps} />
            }
          />
          <Route path={TRANSACTIONS_URL} element={<TransactionsContainer />} />
          <Route
            path={SETTINGS_URL}
            element={
              <UserAccountContainer
                isExchangeEnabled={isExchangeEnabled}
                initKYCProcess={initKYCProcess}
              />
            }
          />
          <Route path={SHOP_URL} element={<RedeemContainer />} />
          <Route path={MY_ITEMS_URL} element={<NftsContainer />} />
          {isExchangeEnabled && !features.disableExchangeLink && (
            <Route
              path={EXCHANGE_POINTS_URL}
              element={<ExchangePointsContainer />}
            />
          )}
          {brandAppConfig.cashbackEarnOption && (
            <Route path={CASHBACK_URL} element={<CashbackContainer />} />
          )}
          <Route
            path={`${REDIRECT_URL}/:path?/:brand?`}
            element={<PageRedirectContainer />}
          />
          {enablePurchasePoints && (
            <Route path={BUY_POINTS_URL} element={<BuyPointsContainer />} />
          )}
          {isQuestsEnabled && (
            <Route path={QUESTS_URL} element={<QuestsContainer />} />
          )}
          {/* {features.rewardBoxes && (
            <Route path={REWARD_BOXES_URL} element={<RewardBoxesContainer />} />
          )} */}
          {features.membership && (
            <Route path={MEMBERSHIP_URL} element={<MembershipContainer />} />
          )}
          {features.staking && (
            <Route
              path={STAKING_URL}
              element={
                <StakingContainer walletConnectProps={walletConnectProps} />
              }
            />
          )}
          <Route path={SCRATCH_CARDS_URL} element={<GamesContainer />} />
          <Route path={POST_TO_EARN_URL} element={<EarnViaContainer />} />
          <Route
            path={INVITE_FRIENDS_URL}
            element={<InviteFriendsContainer />}
          />
          <Route path={PLAY_GAMES_URL} element={<ProdegeContainer />} />
          <Route
            path='*'
            element={<Navigate to={PAGE_NOT_FOUND_URL} replace />}
          />
        </Routes>
        {kycComponent}
      </Suspense>
    </AuthorizedLayoutContainer>
  )
}

export default requireAuth(requireLanguage(HomeContainer))
